import type { Translations } from '../types';

/** العربية (Right-to-left). */
export const ar: Translations = {
  'app.name': 'ITA6',
  'app.tagline': 'مسابقات إلكترونية قائمة على المهارة',
  'app.skipToContent': 'تخطَّ إلى المحتوى الرئيسي',

  'nav.primary': 'التنقل الرئيسي',
  'nav.openMenu': 'افتح القائمة',
  'nav.closeMenu': 'أغلق القائمة',
  'nav.home': 'الرئيسية',
  'nav.dashboard': 'لوحة التحكم',
  'nav.profile': 'الملف الشخصي',
  'nav.admin': 'الإدارة',
  'nav.signIn': 'تسجيل الدخول',
  'nav.signOut': 'تسجيل الخروج',
  'nav.createAccount': 'إنشاء حساب',

  'role.user': 'مشارك',
  'role.admin': 'مسؤول',
  'role.userShort': 'مشارك',
  'role.adminShort': 'مسؤول',

  'status.active': 'نشط',
  'status.suspended': 'موقوف',
  'status.deleted': 'محذوف',
  'status.verified': 'مُوثَّق',
  'status.notVerified': 'غير مُوثَّق',

  'common.loading': 'جارٍ التحميل…',
  'common.refresh': 'تحديث',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.backToHome': 'العودة إلى الرئيسية',
  'common.backToDashboard': 'العودة إلى لوحة التحكم',
  'common.backToContest': 'العودة إلى المسابقة',
  'common.notAvailable': 'غير متاح',

  'theme.label': 'المظهر',
  'theme.light': 'فاتح',
  'theme.dark': 'داكن',
  'theme.system': 'حسب النظام',

  'language.label': 'اللغة',

  'home.hero.title': 'أثبت مهارتك.',
  'home.hero.titleAccent': 'وافز بالجدارة.',
  'home.hero.subtitle':
    'ITA6 منصة مسابقات قائمة على المهارة. شارك في مسابقات تعتمد على القدرات، وأكمل تحديات موقوتة ذات إجابات موضوعية، ودَع قواعد تقييم معلنة — لا الحظ — تحدد الفائزين.',
  'home.hero.goToDashboard': 'الانتقال إلى لوحة التحكم',
  'home.hero.createAccount': 'أنشئ حسابك',
  'home.hero.signIn': 'تسجيل الدخول',
  'home.highlights.title': 'ما تقدمه ITA6',
  'home.highlights.contests': 'تصفّح المسابقات واطّلع على عدد المشاركين',
  'home.highlights.prizes': 'جوائز شفافة تُمَوَّل من رسوم المشاركة',
  'home.highlights.timed': 'تحديات موقوتة بتقييم موثّق من المنصة',
  'home.highlights.results': 'لوحات صدارة تراعي التعادل ونتائج معلنة',
  'home.highlights.admin': 'إدارة قائمة على الأدوار للمسابقات والمستخدمين والجوائز',
  'home.highlights.note':
    'يُفتح باب المشاركة قريبًا. أنشئ حسابك الآن لتكون جاهزًا منذ اليوم الأول.',
  'home.features.title': 'مبنية على العدالة',
  'home.features.subtitle': 'كل قرار تصميمي يخدم هدفًا واحدًا: أن يفوز الأكثر مهارة.',
  'home.features.skill.title': 'مهارة لا حظ',
  'home.features.skill.body':
    'تُحسم المسابقات بالأداء الموضوعي. الفائزون يُحدَّدون وفق قواعد تقييم معلنة — لا بالسحب العشوائي.',
  'home.features.scoring.title': 'تقييم موضوعي',
  'home.features.scoring.body':
    'تُقيَّم الإجابات ويُحسب وقتها داخل المنصة نفسها، فلا يمكن تعديل النتيجة من المتصفح.',
  'home.features.standing.title': 'ترتيب شفاف',
  'home.features.standing.body':
    'عدد المشاركين ومجموع الجوائز ولوحة الصدارة مرئية لكل مشارك، قبل النتيجة وبعدها.',
  'home.features.accounts.title': 'حساب واحد لكل المسابقات',
  'home.features.accounts.body':
    'ملف شخصي موثّق واحد يتتبّع مشاركاتك ونتائجك ومكاسبك على مستوى المنصة كلها.',
  'home.steps.title': 'كيف تسير المسابقة',
  'home.steps.one.title': 'أنشئ ملفك الشخصي',
  'home.steps.one.body': 'سجّل مرة واحدة لتصبح جاهزًا لكل مسابقة على المنصة.',
  'home.steps.two.title': 'اشترك في مسابقة',
  'home.steps.two.body': 'ادفع رسوم المشاركة في مسابقة مهارات تناسب اهتماماتك.',
  'home.steps.three.title': 'خُض التحدي',
  'home.steps.three.body': 'أجب عن أسئلة موضوعية موقوتة بتوقيت عادل تفرضه المنصة.',
  'home.steps.four.title': 'اطّلع على ترتيبك',
  'home.steps.four.body': 'احصل على نتيجة موضوعية وتقدّم في لوحة صدارة شفافة تراعي التعادل.',
  'home.cta.title': 'مستعد لاختبار مهارتك؟',
  'home.cta.body': 'أنشئ حسابًا مجانيًا وكن جاهزًا عند فتح أولى المسابقات.',
  'home.cta.button': 'ابدأ الآن',

  'login.title': 'أهلًا بعودتك',
  'login.subtitle': 'سجّل الدخول إلى حسابك في ITA6.',
  'login.cardTitle': 'تسجيل الدخول',
  'login.cardDescription': 'استخدم البريد الإلكتروني وكلمة المرور التي سجّلت بها.',
  'login.email': 'البريد الإلكتروني',
  'login.emailPlaceholder': 'you@example.com',
  'login.password': 'كلمة المرور',
  'login.passwordPlaceholder': 'كلمة المرور',
  'login.submit': 'تسجيل الدخول',
  'login.noAccount': 'ليس لديك حساب؟',
  'login.createOne': 'أنشئ حسابًا',
  'login.errorRequired': 'أدخل بريدك الإلكتروني وكلمة المرور.',
  'login.errorGeneric': 'تعذّر تسجيل الدخول. حاول مرة أخرى.',

  'register.title': 'أنشئ حسابك',
  'register.subtitle': 'حساب واحد لكل مسابقات ITA6. الانضمام مجاني.',
  'register.cardTitle': 'التسجيل',
  'register.cardDescription': 'كل الحقول مطلوبة ما عدا الاسم المعروض.',
  'register.displayName': 'الاسم المعروض (اختياري)',
  'register.displayNamePlaceholder': 'الاسم الذي يظهر في لوحات الصدارة',
  'register.email': 'البريد الإلكتروني',
  'register.password': 'كلمة المرور',
  'register.passwordPlaceholder': '{min} أحرف على الأقل',
  'register.confirmPassword': 'تأكيد كلمة المرور',
  'register.confirmPlaceholder': 'أعد كتابة كلمة المرور',
  'register.submit': 'إنشاء الحساب',
  'register.securityNote': 'تُخزَّن كلمة المرور بأمان باستخدام تشفير مطابق للمعايير المتبعة.',
  'register.haveAccount': 'لديك حساب بالفعل؟',
  'register.signIn': 'تسجيل الدخول',
  'register.errorGeneric': 'تعذّر إنشاء الحساب. حاول مرة أخرى.',

  'validation.emailRequired': 'البريد الإلكتروني مطلوب.',
  'validation.emailInvalid': 'أدخل بريدًا إلكترونيًا صالحًا.',
  'validation.passwordMin': 'يجب ألا تقل كلمة المرور عن {min} أحرف.',
  'validation.passwordComplexity': 'يجب أن تحتوي كلمة المرور على حرف واحد على الأقل ورقم واحد.',
  'validation.passwordMismatch': 'كلمتا المرور غير متطابقتين.',

  'dashboard.title': 'مرحبًا، {name}',
  'dashboard.subtitle': 'هذه لوحة تحكمك في ITA6. ستظهر هنا مسابقاتك ونتائجك.',
  'dashboard.adminConsole': 'وحدة الإدارة',
  'dashboard.viewProfile': 'عرض الملف الشخصي',
  'dashboard.stat.displayName': 'الاسم المعروض',
  'dashboard.stat.email': 'البريد الإلكتروني',
  'dashboard.stat.role': 'الدور',
  'dashboard.stat.memberSince': 'عضو منذ',
  'dashboard.stat.lastLogin': 'آخر دخول: {date}',
  'dashboard.roleHint.admin': 'صلاحيات إدارية كاملة',
  'dashboard.roleHint.user': 'صلاحيات مشارك',
  'dashboard.contests.title': 'مسابقاتك',
  'dashboard.contests.description': 'ستُدرج هنا المسابقات التي تشترك فيها مع حالتها ونتائجها.',
  'dashboard.contests.empty.title': 'لا توجد مسابقات بعد',
  'dashboard.contests.empty.body':
    'يُفتح باب المشاركة قريبًا. وبمجرد اشتراكك في مسابقة ستظهر هنا.',
  'dashboard.account.title': 'حالة الحساب',
  'dashboard.account.description': 'الوضع الحالي لحسابك.',
  'dashboard.account.status': 'الحالة',
  'dashboard.account.emailVerified': 'البريد موثّق',
  'dashboard.account.role': 'الدور',
  'dashboard.account.id': 'معرّف الحساب',

  'profile.title': 'ملفك الشخصي',
  'profile.subtitle': 'هذه هي المعلومات التي يراها المشاركون الآخرون مع نتائجك.',
  'profile.details.title': 'بيانات الملف الشخصي',
  'profile.details.description': 'معلومات عامة تظهر مع نتائجك.',
  'profile.field.displayName': 'الاسم المعروض',
  'profile.field.country': 'البلد',
  'profile.field.bio': 'نبذة',
  'profile.account.title': 'بيانات الحساب',
  'profile.account.description': 'معلومات حسابك الخاصة.',
  'profile.field.email': 'البريد الإلكتروني',
  'profile.field.emailVerified': 'البريد موثّق',
  'profile.field.role': 'الدور',
  'profile.field.status': 'الحالة',
  'profile.field.memberSince': 'عضو منذ',
  'profile.field.lastLogin': 'آخر دخول',
  'profile.field.accountId': 'معرّف الحساب',

  'admin.title': 'وحدة الإدارة',
  'admin.subtitle': 'حالة المنصة ووصول إداري.',
  'admin.refresh': 'تحديث',
  'admin.loading': 'جارٍ تحميل وحدة الإدارة…',
  'admin.errorLoad': 'تعذّر تحميل حالة المنصة.',
  'admin.signedInAs': 'مسجّل الدخول باسم',
  'admin.users': 'المستخدمون',
  'admin.usersSummary': '{admins} مسؤولًا · {active} نشط',
  'admin.apiLabel': 'واجهة المنصة',
  'admin.apiHealthy': 'تعمل',
  'admin.apiUnavailable': 'غير متاحة',
  'admin.database': 'قاعدة البيانات',
  'admin.databaseOk': 'متّصلة',
  'admin.databaseUnavailable': 'غير متاحة',
  'admin.databaseUnknown': 'غير معروفة',
  'admin.serverTime': 'توقيت الخادم: {date}',
  'admin.session.title': 'الجلسة',
  'admin.session.description': 'بيانات جلستك الإدارية الموثّقة.',
  'admin.field.email': 'البريد الإلكتروني',
  'admin.field.role': 'الدور',
  'admin.field.accountId': 'معرّف الحساب',
  'admin.field.statusChecked': 'وقت الفحص',
  'admin.roadmap.title': 'الإدارة',
  'admin.roadmap.description': 'ما ستديره من هذه الوحدة.',
  'admin.roadmap.contests': 'إنشاء المسابقات والتحديات وضبط إعداداتها',
  'admin.roadmap.questions': 'كتابة الأسئلة وإدارة الإجابات الصحيحة',
  'admin.roadmap.payments': 'مراجعة رسوم المشاركة وقوائم المشاركين',
  'admin.roadmap.results': 'نشر النتائج ولوحات الصدارة وتوزيع الجوائز',
  'admin.roadmap.users': 'الإشراف على المستخدمين وإدارة إعدادات المنصة',

  'guard.checkingSession': 'جارٍ التحقق من جلستك…',
  'guard.accessDenied.title': 'تم رفض الوصول',
  'guard.accessDenied.body':
    'هذه المنطقة مخصّصة للمسؤولين. إن كنت تعتقد أن لك صلاحية الوصول، فتواصل مع مالك المنصة.',

  'notFound.title': 'الصفحة غير موجودة',
  'notFound.body': 'الصفحة التي تبحث عنها غير موجودة أو ربما نُقلت.',

  'api.networkError': 'تعذّر الوصول إلى ITA6. تحقّق من اتصالك وحاول مرة أخرى.',
  'api.requestFailed': 'حدث خطأ ما. حاول مرة أخرى.',
  'api.invalidCredentials': 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
  'api.emailTaken': 'يوجد حساب مسجّل بهذا البريد الإلكتروني بالفعل.',
  'api.accountInactive': 'هذا الحساب غير نشط.',
  'api.sessionExpired': 'انتهت صلاحية جلستك. الرجاء تسجيل الدخول من جديد.',
  'api.unauthorized': 'الرجاء تسجيل الدخول للمتابعة.',
  'api.forbidden': 'لا تملك صلاحية تنفيذ هذا الإجراء.',
  'api.invalidEmail': 'أدخل بريدًا إلكترونيًا صالحًا.',
  'api.weakPassword': 'كلمة المرور لا تستوفي المتطلبات.',
  'api.internalError': 'حدث خطأ من جانبنا. حاول مرة أخرى.',

  'footer.copyright': '© {year} ITA6. جميع الحقوق محفوظة.',
  'footer.legal': 'الشؤون القانونية',
  'footer.terms': 'الشروط',
  'footer.privacy': 'الخصوصية',
  'footer.contact': 'تواصل معنا',

  // --- المرحلة 2: عالم المسابقات -------------------------------------------
  'nav.contests': 'المسابقات',
  'nav.myEntries': 'مشاركاتي',
  'nav.adminContests': 'إدارة المسابقات',
  'nav.adminPayments': 'المدفوعات',

  'common.save': 'حفظ',
  'common.cancel': 'إلغاء',
  'common.close': 'إغلاق',
  'common.confirm': 'تأكيد',
  'common.actions': 'إجراءات',
  'common.status': 'الحالة',
  'common.amount': 'المبلغ',
  'common.date': 'التاريخ',
  'common.none': 'لا شيء',
  'common.submit': 'إرسال',
  'common.details': 'التفاصيل',
  'common.optional': 'اختياري',
  'common.rail': 'قناة الدفع',
  'common.asset': 'الأصل',

  'rail.all': 'جميع المسابقات',
  'rail.fiat': 'نقدي',
  'rail.crypto': 'عملات رقمية',

  'contest.phase.draft': 'مسودة',
  'contest.phase.scheduled': 'مجدولة',
  'contest.phase.registration_open': 'التسجيل مفتوح',
  'contest.phase.registration_closed': 'أُغلق التسجيل',
  'contest.phase.live': 'جارية الآن',
  'contest.phase.awaiting_results': 'في انتظار النتائج',
  'contest.phase.results_ready': 'النتائج متاحة',
  'contest.phase.cancelled': 'ملغاة',
  'contest.phase.voided': 'مُبطلة',

  'participant.status.registered': 'مسجَّل',
  'participant.status.awaiting_payment': 'بانتظار الدفع',
  'participant.status.confirmed': 'مؤكَّد',
  'participant.status.active': 'يشارك',
  'participant.status.completed': 'أكمل',
  'participant.status.disqualified': 'مستبعَد',
  'participant.status.withdrawn': 'منسحب',
  'participant.status.refunded': 'تم رد المبلغ',

  'payment.status.pending': 'بانتظار الدفع',
  'payment.status.confirmed': 'مدفوع',
  'payment.status.failed': 'فشل',
  'payment.status.expired': 'منتهي',
  'payment.status.refunded': 'مُسترد',
  'payment.status.cancelled': 'ملغى',

  'payout.status.pending': 'قيد الانتظار',
  'payout.status.approved': 'معتمد',
  'payout.status.processing': 'قيد المعالجة',
  'payout.status.completed': 'مدفوع',
  'payout.status.failed': 'فشل',
  'payout.status.cancelled': 'ملغى',
  'payout.kind.prize': 'جائزة',
  'payout.kind.refund': 'استرداد',

  'contest.list.title': 'المسابقات',
  'contest.list.subtitle': 'تصفّح المسابقات المفتوحة، واطّلع على مجموع الجوائز، وشارك.',
  'contest.list.empty': 'لا توجد مسابقات مفتوحة حاليًا. عد قريبًا.',
  'contest.list.loadError': 'تعذّر تحميل المسابقات.',
  'contest.list.view': 'عرض المسابقة',

  'contest.card.entry': 'رسم المشاركة',
  'contest.card.free': 'مجانًا',
  'contest.card.prizePool': 'مجموع الجوائز',
  'contest.card.participants': '{count} مشاركًا',
  'contest.card.startsAt': 'تبدأ {date}',
  'contest.card.endsAt': 'تنتهي {date}',

  'contest.countdown.opens': 'يفتح التسجيل خلال',
  'contest.countdown.closes': 'يُغلق التسجيل خلال',
  'contest.countdown.starts': 'تبدأ خلال',
  'contest.countdown.ends': 'تنتهي خلال',
  'contest.countdown.past': 'مغلقة',


  'contest.detail.notFound': 'تعذّر العثور على هذه المسابقة.',
  'contest.detail.loadError': 'تعذّر تحميل هذه المسابقة.',
  'contest.detail.about': 'عن هذه المسابقة',
  'contest.detail.rules': 'القواعد',
  'contest.detail.prizePool': 'مجموع الجوائز',
  'contest.detail.entryFee': 'رسم المشاركة',
  'contest.detail.asset': 'الأصل',
  'contest.detail.paidPlaces': 'عدد المراكز المدفوعة',
  'contest.detail.minParticipants': 'الحد الأدنى للمشاركين',
  'contest.detail.questions': 'الأسئلة',
  'contest.detail.secondsPerQuestion': 'الثواني لكل سؤال',
  'contest.detail.tieBreak': 'معيار كسر التعادل',
  'contest.detail.signInToEnter': 'سجّل الدخول للمشاركة',
  'contest.detail.register': 'المشاركة في المسابقة',
  'contest.detail.registering': 'جارٍ المشاركة…',
  'contest.detail.registered': 'أنت مشارك',
  'contest.detail.start': 'ابدأ المسابقة',
  'contest.detail.continue': 'أكمل المسابقة',
  'contest.detail.viewResults': 'عرض النتائج',
  'contest.detail.payNow': 'افتح صفحة الدفع',
  'contest.detail.paymentPending': 'مشاركتك بانتظار تأكيد الدفع.',
  'contest.detail.paymentConfirmed': 'تم تأكيد دفعتك.',
  'contest.detail.paymentRequired': 'هذه المسابقة تتضمن رسم مشاركة.',
  'contest.detail.providerNotConfigured':
    'الدفع الإلكتروني غير متاح بعد. تواصل مع المنظّم ليؤكد مشاركتك يدويًا.',
  'contest.detail.enterError': 'تعذّرت المشاركة في هذه المسابقة.',
  'contest.detail.cancelled': 'تم إلغاء هذه المسابقة.',
  'contest.detail.voided': 'تم إبطال هذه المسابقة ورد رسوم المشاركة.',

  'contest.play.title': 'المسابقة جارية',
  'contest.play.questionProgress': 'السؤال {current} من {total}',
  'contest.play.timeLeft': 'الوقت المتبقي',
  'contest.play.submit': 'إرسال الإجابة',
  'contest.play.submitting': 'جارٍ الإرسال…',
  'contest.play.submitted': 'تم تسجيل الإجابة',
  'contest.play.answered': 'تمت الإجابة',
  'contest.play.numericPlaceholder': 'أدخل رقمًا، مثال 12.5',
  'contest.play.multiHint': 'اختر كل الخيارات الصحيحة. الإجابة الجزئية لا تُحتسب.',
  'contest.play.next': 'السؤال التالي',
  'contest.play.previous': 'السابق',
  'contest.play.finish': 'إنهاء المسابقة',
  'contest.play.finishing': 'جارٍ الإنهاء…',
  'contest.play.noAnswers': 'لم ترسل أي إجابة بعد. الإنهاء الآن سينهي محاولتك.',
  'contest.play.error': 'تعذّر تسجيل هذه الإجابة.',
  'contest.play.loadError': 'تعذّر تحميل المسابقة.',
  'contest.play.notStarted': 'ابدأ المسابقة من صفحتها أولًا.',
  'contest.play.finishedTitle': 'انتهت المسابقة',
  'contest.play.yourScore': 'نتيجتك',
  'contest.play.correctAnswers': 'الإجابات الصحيحة',
  'contest.play.answeredCount': 'الإجابات المسجلة',
  'contest.play.timeUsed': 'الوقت المستغرق',
  'contest.play.meanwhile': 'ستظهر النتائج النهائية بعد نشرها من المنظّم.',

  'contest.results.title': 'النتائج',
  'contest.results.notPublished': 'لم تُنشر نتائج هذه المسابقة بعد.',
  'contest.results.empty': 'لا توجد نتائج لعرضها.',
  'contest.results.loadError': 'تعذّر تحميل النتائج.',
  'contest.results.winners': 'الفائزون',
  'contest.results.leaderboard': 'الترتيب النهائي',
  'contest.results.rank': 'المركز',
  'contest.results.participant': 'المشارك',
  'contest.results.score': 'النقاط',
  'contest.results.correct': 'الصحيحة',
  'contest.results.time': 'الوقت',
  'contest.results.prize': 'الجائزة',
  'contest.results.export': 'تصدير CSV',
  'contest.results.review': 'مراجعة الإجابات',
  'contest.results.correctAnswer': 'الإجابة الصحيحة',
  'contest.results.explanation': 'التوضيح',


  'entries.title': 'مشاركاتي',
  'entries.subtitle': 'كل مسابقة شاركت فيها، مع نتيجتك وأرباحك.',
  'entries.empty': 'لم تشارك في أي مسابقة بعد.',
  'entries.loadError': 'تعذّر تحميل مشاركاتك.',
  'entries.contest': 'المسابقة',
  'entries.viewContest': 'فتح المسابقة',
  'entries.noResult': 'لا نتيجة بعد',
  'entries.myPayouts': 'مدفوعاتي',
  'entries.payoutsEmpty': 'لا توجد مدفوعات بعد.',

  'admin.queue.title': 'العمليات',
  'admin.queue.description': 'المسابقات ومدفوعات المشاركة والمبالغ المستحقة.',
  'admin.queue.payments': 'مدفوعات بحاجة إلى إجراء',
  'admin.queue.payouts': 'مدفوعات صادرة بحاجة إلى إجراء',
  'admin.queue.reconciliation': 'مُعلَّمة للمطابقة',

  'admin.contests.title': 'المسابقات',
  'admin.contests.subtitle': 'أنشئ المسابقات وأضف الأسئلة وأدر دورة حياتها.',
  'admin.contests.create': 'مسابقة جديدة',
  'admin.contests.empty': 'لا توجد مسابقات بعد.',
  'admin.contests.loadError': 'تعذّر تحميل المسابقات.',
  'admin.contests.formHeading': 'إنشاء مسابقة',
  'admin.contests.formHint':
    'رسم المشاركة والأصل والتوقيت تُثبَّت بعد خروج المسابقة من المسودة، فتحقّق منها بعناية.',
  'admin.contests.field.title': 'العنوان',
  'admin.contests.field.summary': 'ملخص قصير',
  'admin.contests.field.description': 'الوصف',
  'admin.contests.field.rules': 'القواعد',
  'admin.contests.field.rail': 'قناة الدفع',
  'admin.contests.field.asset': 'الأصل',
  'admin.contests.field.entryFee': 'رسم المشاركة (مثال 10.00)',
  'admin.contests.field.sponsor': 'تمويل الراعي (اختياري)',
  'admin.contests.field.feeBps': 'عمولة المنصة (نقاط أساس)',
  'admin.contests.field.minParticipants': 'الحد الأدنى للمشاركين',
  'admin.contests.field.maxParticipants': 'الحد الأعلى للمشاركين',
  'admin.contests.field.paidPlaces': 'عدد المراكز المدفوعة',
  'admin.contests.field.regOpens': 'يفتح التسجيل',
  'admin.contests.field.regCloses': 'يُغلق التسجيل',
  'admin.contests.field.startsAt': 'تبدأ المسابقة',
  'admin.contests.field.endsAt': 'تنتهي المسابقة',
  'admin.contests.field.perQuestionSeconds': 'ثوانٍ لكل سؤال (0 = نافذة المسابقة)',
  'admin.contests.field.tieBreak': 'معيار كسر التعادل',
  'admin.contests.tieBreak.total_time': 'إجمالي زمن الإجابة',
  'admin.contests.tieBreak.earliest_completion': 'الأسبق في الإنهاء',
  'admin.contests.created': 'أُنشئت المسابقة كمسودة.',
  'admin.contests.prizePoolLabel': 'مجموع الجوائز',
  'admin.contests.platformFeeLabel': 'عمولة المنصة',
  'admin.contests.noPublicPage': 'لا توجد صفحة عامة',
  'admin.contests.questions': 'الأسئلة',
  'admin.contests.noQuestions': 'لا توجد أسئلة بعد.',
  'admin.contests.addQuestion': 'إضافة سؤال',
  'admin.contests.questionKind': 'نوع السؤال',
  'admin.contests.kind.single_choice': 'إجابة صحيحة واحدة',
  'admin.contests.kind.multi_choice': 'عدة إجابات صحيحة',
  'admin.contests.kind.true_false': 'صواب أو خطأ',
  'admin.contests.kind.numeric': 'إجابة رقمية',
  'admin.contests.prompt': 'السؤال',
  'admin.contests.points': 'النقاط',
  'admin.contests.options': 'الخيارات',
  'admin.contests.optionLabel': 'الخيار {n}',
  'admin.contests.correct': 'صحيح',
  'admin.contests.numericAnswer': 'الرقم الصحيح',
  'admin.contests.numericTolerance': 'هامش القبول',
  'admin.contests.hintLabel': 'تلميح (اختياري)',
  'admin.contests.explanationLabel': 'توضيح (يظهر مع النتائج)',
  'admin.contests.saveQuestion': 'حفظ السؤال',
  'admin.contests.deleteQuestion': 'حذف السؤال',
  'admin.contests.answerKey': 'مفتاح الإجابة',
  'admin.contests.unkeyed': 'بعض الأسئلة بلا إجابة صحيحة محددة. صحّحها قبل الجدولة.',
  'admin.contests.transitions': 'دورة الحياة',
  'admin.contests.action.schedule': 'جدولة المسابقة',
  'admin.contests.action.finalize': 'اعتماد النتائج',
  'admin.contests.action.publish': 'نشر النتائج',
  'admin.contests.action.cancel': 'إلغاء المسابقة',
  'admin.contests.action.void': 'إبطال ورد الرسوم',
  'admin.contests.cancelReason': 'السبب (يُسجَّل)',
  'admin.contests.participants': 'المشاركون',
  'admin.contests.disqualify': 'استبعاد',
  'admin.contests.disqualifyReason': 'سبب الاستبعاد',
  'admin.contests.payments': 'مدفوعات المشاركة',
  'admin.contests.payouts': 'المدفوعات الصادرة',
  'admin.contests.ledger': 'دفتر الحسابات',
  'admin.contests.transitionDone': 'تم.',


  'admin.payments.title': 'المدفوعات والمدفوعات الصادرة',
  'admin.payments.subtitle': 'تحقّق من المشاركات، وأكّد المدفوعات، وأصدر الجوائز والمبالغ المستردة.',
  'admin.payments.loadError': 'تعذّر تحميل المدفوعات.',
  'admin.payments.entry': 'المشاركة',
  'admin.payments.provider': 'المزوّد',
  'admin.payments.reference': 'المرجع',
  'admin.payments.settle': 'تسجيل التسوية',
  'admin.payments.settleAmount': 'المبلغ المستلم',
  'admin.payments.settleNote': 'ملاحظة',
  'admin.payments.settleDone': 'تم تسجيل التسوية.',
  'admin.payments.resolve': 'إزالة علامة المطابقة',
  'admin.payments.resolveNote': 'ما الذي وجدته؟',
  'admin.payments.expire': 'إنهاء الفاتورة',
  'admin.payments.flagged': 'مُعلَّمة للمطابقة',
  'admin.payouts.title': 'المدفوعات الصادرة',
  'admin.payouts.empty': 'لا توجد مدفوعات صادرة بعد.',
  'admin.payouts.approve': 'اعتماد',
  'admin.payouts.process': 'وضع علامة قيد المعالجة',
  'admin.payouts.complete': 'وضع علامة مدفوع',
  'admin.payouts.fail': 'وضع علامة فشل',
  'admin.payouts.failReason': 'لماذا فشلت؟',
  'admin.payouts.cancel': 'إلغاء الدفعة',
  'admin.payouts.createRefunds': 'رد جميع الرسوم المؤكدة',
  'admin.ledger.title': 'دفتر الحسابات',
  'admin.ledger.balances': 'الأرصدة حسب القناة',
  'admin.ledger.note': 'الأرصدة لكل قناة ولكل أصل على حدة، ولا تُجمَع بين القنوات أبدًا.',
  'admin.ledger.entryType': 'النوع',
  'admin.ledger.direction': 'الاتجاه',
  'admin.ledger.credits': 'وارد',
  'admin.ledger.debits': 'صادر',
  'admin.ledger.net': 'الصافي',

  'api.contestNotFound': 'هذه المسابقة غير موجودة.',
  'api.registrationClosed': 'التسجيل في هذه المسابقة مغلق.',
  'api.contestFull': 'هذه المسابقة مكتملة العدد.',
  'api.notEnrolled': 'أنت غير مسجّل في هذه المسابقة.',
  'api.notActive': 'أنت لا تشارك حاليًا في هذه المسابقة.',
  'api.entryNotConfirmed': 'لم يتم تأكيد مشاركتك بعد.',
  'api.contestNotLive': 'هذه المسابقة غير مفتوحة للمشاركة.',
  'api.alreadyAnswered': 'لقد أجبت عن هذا السؤال بالفعل.',
  'api.submissionRejected': 'لم تُقبل هذه الإجابة — أُغلقت نافذة المسابقة.',
  'api.answerInvalid': 'هذه الإجابة غير صالحة لهذا السؤال.',
  'api.resultsNotPublished': 'لم تُنشر النتائج بعد.',
  'api.rateLimited': 'طلبات كثيرة جدًا. انتظر قليلًا ثم حاول مجددًا.',
  'api.paymentNotFound': 'هذه الدفعة غير موجودة.',
  'api.payoutNotFound': 'هذه الدفعة الصادرة غير موجودة.',
  'api.notFinalized': 'اعتمد المسابقة قبل نشر نتائجها.',
  'api.reasonRequired': 'السبب مطلوب.',
  'api.idempotencyKeyReused': 'استُخدم هذا الطلب مسبقًا لإجابة مختلفة.',
  'api.contestNotEditable': 'لا يمكن تعديل المسابقة إلا في حالة المسودة.',
  'api.contentLocked': 'لا يمكن تغيير محتوى المسابقة بعد بدء المسابقة.',
  'api.invalidAmount': 'أدخل مبلغًا صالحًا، مثال 10.00',
  'api.assetRailMismatch': 'هذا الأصل لا ينتمي إلى قناة الدفع المختارة.',
  'api.unknownAsset': 'هذا الأصل غير مدعوم.',
  'api.invalidWindow': 'أوقات التسجيل والمسابقة غير مرتبة بشكل صحيح.',
  'api.contestHasNoQuestions': 'أضف سؤالًا واحدًا على الأقل قبل جدولة المسابقة.',
  'api.questionWithoutAnswerKey': 'كل سؤال يحتاج إجابة صحيحة قبل الجدولة.',
  'api.answerKeyRequired': 'حدّد الإجابة الصحيحة لهذا السؤال.',
  'api.optionsRequired': 'سؤال الاختيار يحتاج خيارين على الأقل.',
  'api.transitionContended': 'تغيّرت المسابقة أثناء عملك. أعد التحميل وحاول مجددًا.',
  'api.invalidTransition': 'هذا التغيير في دورة الحياة غير مسموح لهذه المسابقة.',
  'api.notFlagged': 'هذه الدفعة لا تنتظر المطابقة.',


  'pay.title': 'الدفع بعملة USDT',
  'pay.notIssued': 'لا يُطلب أي دفع مقابل هذه المشاركة.',
  'pay.amount': 'المبلغ المطلوب إرساله',
  'pay.network': 'الشبكة',
  'pay.address': 'عنوان الإيداع',
  'pay.copy': 'نسخ العنوان',
  'pay.copied': 'تم نسخ العنوان',
  'pay.openInWallet': 'افتح في المحفظة',
  'pay.received': 'المستلَم',
  'pay.confirmations': 'التأكيدات',
  'pay.txHash': 'المعاملة',
  'pay.viewOnExplorer': 'عرض في مستكشف الكتل',
  'pay.expires': 'ادفع قبل',
  'pay.checkNow': 'لقد دفعت — تحقّق الآن',
  'pay.checking': 'جارٍ التحقق من البلوكشين…',
  'pay.autoCheck': 'نتحقّق من البلوكشين تلقائيًا أيضًا.',
  'pay.qrLabel': 'رمز QR لعنوان الإيداع',
  'pay.scanHint': 'امسح الرمز بتطبيق المحفظة، أو انسخ العنوان.',
  'pay.awaitingHint':
    'أرسل هذا المبلغ بالضبط من USDT على هذه الشبكة إلى العنوان أدناه. العنوان مخصص لهذه المشاركة فقط.',
  'pay.detectedHint': 'نرى تحويلك على البلوكشين.',
  'pay.confirmingHint': 'تحويلك على البلوكشين وينتظر التأكيدات. ستُفعَّل مشاركتك تلقائيًا.',
  'pay.confirmedHint': 'تم تأكيد الدفع. أنت الآن مشارك في هذه المسابقة.',
  'pay.overpaidHint': 'تم تأكيد الدفع. أرسلت أكثر من رسم المشاركة؛ وسُجِّل الفائض للمراجعة.',
  'pay.underpaidHint':
    'المبلغ المستلم أقل من رسم المشاركة. أرسل المتبقي إلى العنوان نفسه أو تواصل مع الدعم.',
  'pay.expiredHint': 'انتهت صلاحية هذه الفاتورة. ابدأ المشاركة مجددًا للحصول على عنوان جديد.',
  'pay.invalidHint':
    'استلمنا تحويلًا غير مقبول لهذه المشاركة (أصل أو شبكة غير صحيحة). تواصل مع الدعم.',
  'pay.failedHint': 'تعذّر ربط هذا الدفع بهذه المشاركة. تواصل مع الدعم.',
  'pay.status.awaiting_payment': 'بانتظار الدفع',
  'pay.status.detected': 'تم الاكتشاف',
  'pay.status.confirming': 'قيد التأكيد',
  'pay.status.confirmed': 'مؤكَّد',
  'pay.status.underpaid': 'دفع ناقص',
  'pay.status.overpaid': 'دفع زائد',
  'pay.status.expired': 'منتهي',
  'pay.status.invalid': 'غير مقبول',
  'pay.status.failed': 'فشل',

  'login.google': 'المتابعة بحساب Google',
  'login.or': 'أو',
  'login.staffNote': 'تسجيل الدخول بكلمة المرور متاح للموظفين والحسابات القائمة.',
  'login.googleError.cancelled': 'تم إلغاء تسجيل الدخول بحساب Google. يمكنك المحاولة مرة أخرى.',
  'login.googleError.unavailable':
    'تسجيل الدخول بحساب Google غير متاح على هذا الإصدار. استخدم طريقة أخرى أو تواصل مع الدعم.',
  'login.googleError.accountConflict':
    'تعذّر تسجيل دخولك بهذا الحساب من Google لأنه مرتبط بالفعل بحساب آخر في ITA6. تواصل مع الدعم.',
  'login.googleError.accountInactive': 'حساب ITA6 هذا غير مُفعَّل. تواصل مع الدعم.',
  'login.googleError.failed': 'لم يكتمل تسجيل الدخول بحساب Google. حاول مرة أخرى.',
  'register.google': 'إنشاء حساب بحساب Google',
  'nav.adminCrypto': 'العملات الرقمية',
  'admin.crypto.title': 'لوحة العملات الرقمية',
  'admin.crypto.subtitle':
    'USDT على الشبكة: مخزون عناوين الإيداع، والفواتير، والتحويلات المرصودة، والمدفوعات الصادرة، والمطابقة.',
  'admin.crypto.loadError': 'تعذّر تحميل لوحة العملات الرقمية.',
  'admin.crypto.rails': 'قنوات الدفع',
  'admin.crypto.railsDisabled': 'معطّلة',
  'admin.crypto.networks': 'الشبكات وعناوين الإيداع',
  'admin.crypto.available': 'متاح',
  'admin.crypto.unsupported': 'غير مدعومة',
  'admin.crypto.pool': 'مخزون عناوين الإيداع',
  'admin.crypto.poolHint':
    'كل مشاركة تستهلك عنوان إيداع واحدًا. وعند نفاد المخزون تُرفض المشاركات بدلًا من إعطائها عنوانًا لا يمكن إسناده — لذلك استورد عناوين إضافية قبل ذلك بوقت كافٍ.',
  'admin.crypto.importNetwork': 'الشبكة',
  'admin.crypto.importAsset': 'الرمز',
  'admin.crypto.poolFilter': 'عرض',
  'admin.crypto.poolStatus.available': 'متاح',
  'admin.crypto.poolStatus.assigned': 'مُخصَّص',
  'admin.crypto.poolStatus.retired': 'مسحوب',
  'admin.crypto.import': 'استيراد عناوين عامة',
  'admin.crypto.importPlaceholder': 'عنوان واحد في كل سطر',
  'admin.crypto.importHint':
    'عناوين عامة فقط — لا مفاتيح خاصة أبدًا. يُتحقَّق من كل سطر وفق التنسيق الحقيقي للشبكة، ويرفض أي مدخل غير صحيح عملية الاستيراد بالكامل.',
  'admin.crypto.importButton': 'استيراد العناوين',
  'admin.crypto.importEmpty': 'الصق عنوانًا واحدًا على الأقل.',
  'admin.crypto.imported': 'تم استيراد {count} عنوانًا. المتاح الآن: {available}.',
  'admin.crypto.address': 'العنوان',
  'admin.crypto.network': 'الشبكة',
  'admin.crypto.status': 'الحالة',
  'admin.crypto.assignedTo': 'مُخصَّص لـ',
  'admin.crypto.empty': 'لا يوجد ما يُعرض.',
  'admin.crypto.runMonitor': 'تشغيل مراقب الشبكة',
  'admin.crypto.monitorDone': 'انتهى المراقب: فُحص {examined} وتمت تسوية {settled}.',
  'admin.crypto.signer': 'توقيع المدفوعات الصادرة',
  'admin.crypto.signerReady': 'الموقِّع مُهيَّأ',
  'admin.crypto.signerMissing':
    'لا يوجد موقِّع مُهيَّأ — لا يمكن بثّ المدفوعات الصادرة تلقائيًا. ويمكن إرسالها يدويًا مع تسجيل رمز المعاملة.',
  'admin.crypto.payoutWallet': 'محفظة المدفوعات الصادرة',
  'admin.crypto.payoutWalletMissing': 'غير مُهيَّأة',
  'admin.crypto.emulator': 'محاكي الشبكة',
  'admin.crypto.emulatorOn': 'مُفعَّل — للتدريب فقط، وليس في الإنتاج أبدًا',
  'admin.crypto.emulatorOff': 'معطَّل',
  'admin.crypto.emulatorQueued': '{count} رصد في الانتظار',
  'admin.crypto.stuck': 'مدفوعات تحتاج إلى تدخّل',
  'admin.crypto.recheck': 'إعادة التحقق الآن',
  'admin.crypto.recheckDone': 'تمت إعادة التحقق من الشبكة.',
  'admin.crypto.invoices': 'فواتير العملات الرقمية',
  'admin.crypto.participant': 'المشارك',
  'admin.crypto.expected': 'المطلوب',
  'admin.crypto.received': 'المستلَم',
  'admin.crypto.confirmations': 'التأكيدات',
  'admin.crypto.depositAddress': 'عنوان الإيداع',
  'admin.crypto.txHash': 'المعاملة',
  'admin.crypto.amount': 'المبلغ',
  'admin.crypto.classification': 'التصنيف',
  'admin.crypto.from': 'من',
  'admin.crypto.transfers': 'التحويلات المرصودة على الشبكة',
  'admin.crypto.reconciliation': 'المطابقة',
  'admin.crypto.reconciliationHint':
    'ما سجّلناه مقابل ما تقوله الشبكة. يُعرض أي فرق ولا يُصحَّح تلقائيًا أبدًا.',
  'admin.crypto.applicationIn': 'مسجَّل وارد',
  'admin.crypto.applicationOut': 'مسجَّل صادر',
  'admin.crypto.observed': 'المرصود على الشبكة',
  'admin.crypto.discrepancy': 'الفرق',
  'admin.crypto.notReadable': 'تعذّرت قراءته من الشبكة',
  'admin.crypto.unmatched': 'تحويلات شبكية غير مطابقة',
  'admin.crypto.payoutsHint': 'اعتمد ووقّع وسوّ المدفوعات الصادرة هناك.',
  'admin.crypto.mode': 'التوقيع',
  'admin.crypto.mode.inWorker': 'داخل الـ Worker',
  'admin.crypto.mode.externalSigner': 'موقِّع خارجي',
  'admin.crypto.mode.manualOnly': 'يدوي فقط',
  'legal.privacy': 'سياسة الخصوصية',
  'legal.terms': 'الشروط والأحكام',
  'legal.lastUpdated': 'آخر تحديث {date}',
  'legal.authoritativeNote':
    'تُقدَّم هذه الوثيقة بعدة لغات. وإذا اختلفت الترجمة عن النص الإنجليزي، فالنص الإنجليزي هو المرجع.',

};
